import { Component, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from 'src/app/components/sesion/login/login.component';
import { ContainerComponent } from './components/container/container.component';
import { NotFoundComponent } from './components/helpers/not-found/not-found.component';
import { LoginGuard } from './guards/login.guard';
import { MainGuard } from './guards/main.guard';
import { HomeComponent } from './components/home/home.component';

const routes: Routes = [
  {
    path: '', canActivate: [LoginGuard], children: [//LoginGuard
      { path: '', pathMatch: 'full', redirectTo: 'login' },
      { path: 'login', component: LoginComponent }
    ]
  },
  {
    path: 'index',canActivate:[MainGuard], component: ContainerComponent, children: [
      { path: '', component: HomeComponent }
    ]
  },
  //{ path: 'index', component: ContainerComponent, canActivate: [MainGuard] },
  { path: 'catalogos', component: ContainerComponent, loadChildren: () => import('./modules/catalogos/catalogos.module').then(m => m.CatalogosModule), canActivate: [MainGuard] },
  { path: 'suministros', component: ContainerComponent, loadChildren: () => import('./modules/suministros/suministros.module').then(m => m.SuministrosModule), canActivate: [MainGuard] },
  { path: 'reportes', component: ContainerComponent, loadChildren: () => import('./modules/reportes/reportes.module').then(m => m.ReportesModule), canActivate: [MainGuard] },
  { path: 'monitoreo', component: ContainerComponent, loadChildren: () => import('./modules/monitoreo/monitoreo.module').then(m => m.MonitoreoModule), canActivate: [MainGuard] },
  { path: '404', component: NotFoundComponent },
  { path: '**', pathMatch: 'full', redirectTo: '404' },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
